import React from "react";
import ProductGrid from "../components/ProductGrid";
import PromoStrip from "../components/PromoStrip";

export default function Accesorios() {
  return (
    <>
      <PromoStrip />
      <ProductGrid
        title="Catálogo completo"
        subtitle="Fundas y accesorios para todos los gustos."
      />
    </>
  );
}
